import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { useTranslation } from "react-i18next";

function VisaPrepUniEnrolmentStep2(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.QUALIFICATION_AS_PROOF_OF_ENGLISH}
        label={t('forms.visa:areYouUsingAPreviousQualificatio')}
        value={boolToYesNo(props.qualificationAsProofOfEnglish)}
      />
      {props.qualificationAsProofOfEnglish ? (
        <SummaryRow
          className={'visa-summary'}
          key={VQ.QUALIFICATION_AND_COUNTRY}
          value={props.qualificationAndCountry}
          label={t('forms.visa:qualificationAndCountry')}
          fullLabel={'Please state your academic qualification and the country it was taught in:'}
        />
      ) : null}
    </>
  );
}

export default VisaPrepUniEnrolmentStep2;
